import { render, staticRenderFns } from "./DetailsLog.vue?vue&type=template&id=66d2e3e9"
import script from "./DetailsLog.vue?vue&type=script&lang=ts"
export * from "./DetailsLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports